module.exports = __webpack_public_path__ + "static/media/jay-z.c34e41c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/opponent/jay-z.jpg
// module id = 91
// module chunks = 0